// Generated by purs version 0.15.0
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Geocoding_RPC_Sites_Types from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
import * as Utils_DataLoading from "../Utils.DataLoading/index.js";
var hoistErrors = function (v) {
    if (v instanceof Data_Either.Left) {
        return new Data_Either.Left(Utils_DataLoading.NetworkError.value);
    };
    if (v instanceof Data_Either.Right) {
        return new Data_Either.Right(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Services.Geocoding.Higgs (line 30, column 1 - line 30, column 60): " + [ v.constructor.name ]);
};
var geocode = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return function (country) {
                return function (streetAddress) {
                    return Restaumatic_Site_RPC.sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Geocoding_RPC_Sites_Types.encodeGeocodeRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_RPC_Sites_Types.encodeGeocodeRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Geocoding_RPC_Sites_Types.decodeGeocodeResponse))(Restaumatic_Geocoding_RPC_Sites_Types.rpcMethodNameGeocodeRequest)({
                        country: country,
                        streetAddress: streetAddress,
                        fromPS: new Data_Maybe.Just(fromPS),
                        restaurantId: restaurantId,
                        accountId: accountId
                    });
                };
            };
        };
    };
};
var convertCoords = function (v) {
    return {
        latitude: v.lat,
        longitude: v.lon
    };
};
var geocodeAddress = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return function (country) {
                return function (address) {
                    return Data_Functor.map(Effect_Aff.functorAff)((function () {
                        var $9 = Data_Functor.map(Data_Either.functorEither)((function () {
                            var $11 = Data_Newtype.unwrap();
                            return function ($12) {
                                return (function (c) {
                                    return {
                                        location: Data_Functor.map(Data_Maybe.functorMaybe)(convertCoords)(c)
                                    };
                                })((function (v) {
                                    return v.coordinates;
                                })($11($12)));
                            };
                        })());
                        return function ($10) {
                            return $9(hoistErrors($10));
                        };
                    })())(geocode(accountId)(restaurantId)(fromPS)(country)(address));
                };
            };
        };
    };
};
var higgsGeocoding = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return {
                geocodeAddress: geocodeAddress(accountId)(restaurantId)(fromPS)
            };
        };
    };
};
export {
    higgsGeocoding
};
//# sourceMappingURL=index.js.map
